export const chartColors = [
    "#4F46E5",
    "#22C55E",
    "#EF4444",
    "#F59E0B",
    "#3B82F6",
    "#EC4899",
    "#10B981",
    "#8B5CF6",
    "#F97316",
    "#14B8A6",
    "#6366F1",
    "#84CC16",
    "#E11D48",
    "#0EA5E9",
    "#A855F7",
    "#F43F5E",
    "#22D3EE",
    "#D946EF",
    "#FACC15",
    "#6B7280",
];
